import React from 'react';
import { OkrPopUp } from '../../types/okrpopup.types';
import OKRPopupName from './okr_header/okrHeaderName';
import OKRHeaderKebab from './okr_header/okrHeaderKebab';
import OKRHeaderProfile from './okr_header/okrHeaderProfile';

const OkrHead = ({ goalData, dispatch }: OkrPopUp) => (
    <div className="okr_header">
        <OKRHeaderProfile
            goalOwnerPic={goalData.goalOwnerPic}
        />
        <OKRPopupName
            goalOwnerName={goalData.goalOwnerName}
            goal={goalData.goals.goal}
            teamName={goalData.goals.teamName}
            goalPercentage={goalData.goals.goal_percentage}
            goalPercentageColor={goalData.goals.goal_percentage_color}
            achievedGoal={goalData.goals.achieved_goal}
            closed_by={goalData.goals.closed_by}
        />
        <OKRHeaderKebab
            goals={goalData.goals}
            isFavorites={goalData.isFavorites}
            dispatch={dispatch}
            scrollY={goalData.scrollY}
            goalOldUrl={ goalData.oldId ? goalData.oldId : ''}
        />
    </div>
)

export default OkrHead;
